import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Sparkles, ArrowRight } from 'lucide-react';

export const NextRetreatModule = ({ onPriorityList }) => (
  <section id="next-retreat" className="py-20 px-6 bg-white" data-testid="next-retreat-module">
    <div className="max-w-3xl mx-auto text-center">
      <Badge className="bg-terracotta/10 text-terracotta mb-4 tracking-widest uppercase">The Next Just Be Experience</Badge>
      <div className="mx-auto h-14 w-14 rounded-full bg-forest/5 flex items-center justify-center mb-6">
        <Sparkles className="h-7 w-7 text-terracotta" />
      </div>
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-forest mb-6">
        Where Will We Just Be Next?
      </h2>
      <div className="space-y-4 text-gray-700 text-lg leading-relaxed mb-8">
        <p>The next Sister Diamonds retreat experience is being curated.</p>
        <p>
          Our retreats are intentionally intimate, which means space is limited. Join the priority list to be among
          the first to learn the destination, dates, and early registration opportunities.
        </p>
      </div>
      <Button
        onClick={onPriorityList}
        size="lg"
        className="bg-terracotta hover:bg-terracotta/90 text-white px-8 py-6 text-lg tracking-wide"
        data-testid="next-retreat-priority-btn"
      >
        Join the Retreat Priority List <ArrowRight className="ml-2 h-5 w-5" />
      </Button>
    </div>
  </section>
);
